import React, { useState } from 'react';
import Modal from '../../components/Modal';
import get from '../../helpers/data_layer/get';

const PauseAnyTimeSellingPointMobile = ({
  productType,
  sellingPoint,
  subText,
  onOpen,
}) => {
  const [showDialog, setShowDialog] = useState(false);

  const close = () => setShowDialog(false);
  const open = () => setShowDialog(true);

  const someOneOrWhere = productType == 'bold' ? 'someone' : 'somewhere';

  return (
    <>
      <button
        onClick={() => {
          open();
          if (onOpen) {
            onOpen();
          }
        }}
        type="button"
        className="button button--link product-selector__selling-points-success-guarantee"
      >
        {sellingPoint}
      </button>
      {subText}
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText="Pause your upgrade"
          id="pauseAnyTimeText"
          initialFocus=".modal__close"
        >
          <p>
            If you manage to find {someOneOrWhere} in, say, 2 weeks, simply
            pause your advertising for another time (your access can only be
            paused once and must all be used within 1 year)
          </p>
        </Modal>
      ) : null}
    </>
  );
};

export default PauseAnyTimeSellingPointMobile;
